import React, { useState, useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import { FiArrowDown } from "react-icons/fi";
import { Link } from "react-scroll";
import "./Home.css";

const Home = () => {
  const [displayText, setDisplayText] = useState("");
  const [roleIndex, setRoleIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  const roles = useMemo(
    () => [
      "Frontend Developer",
      "Next.js Developer",
      "UI/UX Enthusiast",
      "Creative Problem Solver",
    ],
    [],
  );

  useEffect(() => {
    const currentRole = roles[roleIndex];
    const timeout = setTimeout(
      () => {
        if (!isDeleting) {
          if (displayText.length < currentRole.length) {
            setDisplayText(currentRole.slice(0, displayText.length + 1));
          } else {
            setTimeout(() => setIsDeleting(true), 2000);
          }
        } else {
          if (displayText.length > 0) {
            setDisplayText(displayText.slice(0, -1));
          } else {
            setIsDeleting(false);
            setRoleIndex((prev) => (prev + 1) % roles.length);
          }
        }
      },
      isDeleting ? 50 : 100,
    );

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, roleIndex, roles]);

  return (
    <section id="home" className="hero">
      {/* Left Panel */}
      <div className="hero-panel left">
        <span className="vertical-text">Empowering Ideas</span>
        <div className="panel-image">
          <div className="image-content">
            <img
              src="/images/left-panel.jpg"
              alt=""
              onError={(e) => {
                e.target.style.display = "none";
                e.target.parentElement.innerHTML = "<span>CODE</span>";
              }}
            />
          </div>
        </div>
      </div>

      {/* Center Content */}
      <div className="hero-center">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          {/* Main Name */}
          <div className="hero-name">
            <span className="name-white">Diana</span>
            <span className="name-outline">Gafita</span>
          </div>

          {/* Subtitle */}
          <p className="hero-subtitle">
            Dynamic {displayText}
            <span className="cursor">|</span>
          </p>

          {/* Mobile CTAs */}
          <div className="hero-ctas">
            <Link
              to="projects"
              smooth={true}
              duration={800}
              offset={-80}
              className="hero-cta-link primary"
            >
              View Work →
            </Link>
            <Link
              to="contact"
              smooth={true}
              duration={800}
              offset={-80}
              className="hero-cta-link secondary"
            >
              Contact →
            </Link>
          </div>
        </motion.div>

        {/* Floating Image */}
        <motion.div
          className="hero-floating-image"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <div className="floating-image-content">
            <img
              src="/images/hero-image.jpg"
              alt=""
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
          <div className="image-glow"></div>
        </motion.div>
      </div>

      {/* Right Panel */}
      <div className="hero-panel right">
        <div className="panel-image">
          <div className="image-content">
            <img
              src="/images/right-panel.jpg"
              alt=""
              onError={(e) => {
                e.target.style.display = "none";
                e.target.parentElement.innerHTML = "<span>UI</span>";
              }}
            />
          </div>
        </div>
        <span className="vertical-text">Captivating Global Audiences</span>
      </div>

      {/* Mobile ticker */}
      <div className="hero-ticker">
        <div className="ticker-track">
          {[
            "Frontend Dev",
            "Next.js",
            "React",
            "UI/UX",
            "Tailwind",
            "TypeScript",
            "Frontend Dev",
            "Next.js",
            "React",
            "UI/UX",
            "Tailwind",
            "TypeScript",
          ].map((t, i) => (
            <span key={i} className="ticker-item">
              {t} <span className="ticker-dot">•</span>
            </span>
          ))}
        </div>
      </div>

      {/* Scroll Indicator - Outside hero-center */}
      <Link
        to="about"
        spy={true}
        smooth={true}
        offset={-50}
        duration={800}
        className="scroll-indicator"
      >
        <div className="scroll-circle">
          <svg viewBox="0 0 100 100">
            <defs>
              <path
                id="circlePath"
                d="M 50,50 m -37,0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0"
              />
            </defs>
            <text className="circle-text">
              <textPath href="#circlePath">
                SCROLL TO EXPLORE • SCROLL TO EXPLORE •
              </textPath>
            </text>
          </svg>
          <div className="scroll-arrow">
            <FiArrowDown />
          </div>
        </div>
      </Link>
    </section>
  );
};

export default Home;
